/**
 * Media types that cross the API boundary. The backend sets them on a response
 * and the frontend asserts them on arrival, so a single literal keeps the two
 * halves of the contract from drifting apart.
 */

export const XLSX_CONTENT_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const XLSX_EXTENSION = ".xlsx";
